import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledFab from 'components/atoms/Fabs/Fab/Fab.styles';
import utils from 'helpers/utils';
import {withMemo} from 'helpers/wrapper';
import Skeleton from 'components/atoms/Skeletons/Skeleton/Skeleton';
import Component from 'components/organisms/Utils/Component/Component';

const Fab = withMemo(React.forwardRef((props, ref) => {
  const {
    badge,
    isLoading,
    BadgeProps,
    ...innerProps
  } = useComponentProps(props, 'Fab', {
    static: ['selected']
  });

  const renderChildren = () => {
    if (badge) {
      return <Component Original={badge}
                        className="IconButton-badge"
                        size="small"
                        disabled={innerProps.disabled}
                        isLoading={isLoading}
                        {...BadgeProps}>
        {innerProps.children}
      </Component>;
    } else {
      return innerProps.children;
    }
  }

  const renderFab = () => {
    return <StyledFab ref={ref} {...innerProps}>
      {renderChildren()}
    </StyledFab>
  }

  innerProps.className = utils.flattenClassName(innerProps.className);

  if (isLoading) {
    return <Skeleton className={innerProps.className} variant="circular">
      {renderFab()}
    </Skeleton>
  } else {
    return renderFab();
  }
}));

Fab.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  badge: PropTypes.any,
  BadgeProps: PropTypes.object
};

export default Fab;
